import { bootstrapFrontendErrors } from './bootstrapFrontendErrors';
import { createFetchWithErrorSummary } from './fetchWithErrorSummary';
import { installGlobalTracePropagation } from './globalPropagation';
import { installActionTracker } from './actionTracker';
import { initOtlpExporter } from './otlpExporter';
import type { ObservabilityConfig } from './types';

export { FrontendErrorBoundary } from './FrontendErrorBoundary';
export { reportFrontendError } from './reportFrontendError';
export { newTraceparent, shouldPropagateTo } from './browserTracing';
export { snapshotBreadcrumbs } from './actionTracker';
export type { FrontendErrorEvent, FrontendErrorEventType, ObservabilityConfig } from './types';

export interface ObservabilityHandle {
  fetch: ReturnType<typeof createFetchWithErrorSummary>;
}

const DEFAULT_OTLP_PATH = '/clip/otel/v1/traces';

export function initObservability(config: ObservabilityConfig): ObservabilityHandle {
  bootstrapFrontendErrors(config.applicationName);

  // Action breadcrumbs must be installed before fetch/XHR are wrapped so
  // the very first request already has a `nav` breadcrumb for the initial
  // page load.
  installActionTracker();

  const otlpPath = config.otlpTracesPath ?? DEFAULT_OTLP_PATH;
  if (otlpPath) {
    initOtlpExporter({
      serviceName: config.applicationName,
      serviceVersion: config.serviceVersion,
      endpointPath: otlpPath,
    });
  }

  // Patch global fetch + XHR so every outbound API call gets a traceparent
  // and a corresponding browser-side CLIENT span. Callers don't have to
  // opt in by adopting the returned wrapper.
  installGlobalTracePropagation({
    propagationTargets: config.propagationTargets,
    serviceName: config.applicationName,
  });
  return {
    fetch: createFetchWithErrorSummary(config),
  };
}
